import React from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import { useEventForDownloadsLazyQuery } from '../../../graphql/queries/eventForDownloads.generated';
import DownloadsModal from './DownloadsModal';
import ClassicLoadingSpinner from '../../../components/LoadingSpinner/ClassicLoadingSpinner';
import i18n from '@/utils/i18n';
import { EventAccount } from '../../../graphql/generatedTypes';
import { EventData } from './EventList';

type DownloadsModalWrapperProps = {
  isOpen: boolean;
  eventItem: EventData;
  eventAccount?: EventAccount;
  showDeposit: boolean;
  onClose: () => void;
};

const DownloadsModalWrapper = ({
  isOpen,
  eventItem,
  eventAccount,
  showDeposit,
  onClose,
}: DownloadsModalWrapperProps) => {
  const [getFullEventData, { data, loading, error }] =
    useEventForDownloadsLazyQuery({
      fetchPolicy: 'no-cache',
    });

  // Fetch full event data when modal opens
  React.useEffect(() => {
    if (isOpen && !data && !loading) {
      getFullEventData({
        variables: { eventId: eventItem.id },
      });
    }
  }, [isOpen, eventItem.id, data, loading, getFullEventData]);

  const fullEvent = data?.event;

  return (
    <Modal isOpen={isOpen} keyboard={true} onClosed={onClose} toggle={onClose}>
      <ModalHeader toggle={onClose}>
        {eventItem.name} {i18n.t('Common:downloads')}
      </ModalHeader>

      <ModalBody>
        {loading && (
          <div className="py-4 text-center">
            <ClassicLoadingSpinner />
            <p>{i18n.t('Common:loading')}...</p>
          </div>
        )}

        {error && (
          <div className="py-4 text-center">
            <p className="text-danger">
              {i18n.t('Common:error')}: {error.message}
            </p>
          </div>
        )}

        {fullEvent && (
          <DownloadsModal
            event={fullEvent}
            eventAccount={eventAccount}
            showDeposit={showDeposit}
            showInvoice
            showOrderfulfillment
            showEventOpsOrders={false}
            showAllEventOpsOrders={false}
            showAuthorizedSigner
          />
        )}

        <div className="d-flex justify-content-end">
          <Button onClick={onClose}>{i18n.t('Common:cancel')}</Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DownloadsModalWrapper;
